module.exports = __webpack_public_path__ + "img/7.87a75e19.png";